export enum PATH {
    HOME = '/',
    CHILD = '/excursii-scolare',
    SENIOR = '/excursii-seniori',
    SENIOR_TRIP = '/excursie-seniori',
    FUNDS = '/fonduri-nerambursabile',
    TEAM = '/echipa',
    CONTACT = '/contact',
    RENT = '/inchiriere-autocare'
}